// This file is auto-generated. Do not edit manually.
// Run "npm run -w packages/iconik-api generate" to regenerate.
/** biome-ignore-all lint/complexity/noBannedTypes: some API definitions are unclear */
import { httpMethod } from '../constants';
import type { IconikApiHeaders } from '../types';

export const UsersNotificationsHttpPostDeviceTokens =
  'UsersNotificationsHttpPostDeviceTokens' as const;
export const UsersNotificationsHttpGetNotificationSettings =
  'UsersNotificationsHttpGetNotificationSettings' as const;
export const UsersNotificationsHttpGetNotificationSettingsByObjectTypeBySubObjectTypeByEventTypeByProtocol =
  'UsersNotificationsHttpGetNotificationSettingsByObjectTypeBySubObjectTypeByEventTypeByProtocol' as const;
export const UsersNotificationsHttpPutNotificationSettingsByObjectTypeBySubObjectTypeByEventTypeByProtocol =
  'UsersNotificationsHttpPutNotificationSettingsByObjectTypeBySubObjectTypeByEventTypeByProtocol' as const;
export const UsersNotificationsHttpGetNotifications =
  'UsersNotificationsHttpGetNotifications' as const;
export const UsersNotificationsHttpPostNotifications =
  'UsersNotificationsHttpPostNotifications' as const;
export const UsersNotificationsHttpPutNotificationsAllRead =
  'UsersNotificationsHttpPutNotificationsAllRead' as const;
export const UsersNotificationsHttpPostNotificationsSystem =
  'UsersNotificationsHttpPostNotificationsSystem' as const;
export const UsersNotificationsHttpDeleteNotificationsByNotificationId =
  'UsersNotificationsHttpDeleteNotificationsByNotificationId' as const;
export const UsersNotificationsHttpGetNotificationsByNotificationId =
  'UsersNotificationsHttpGetNotificationsByNotificationId' as const;
export const UsersNotificationsHttpPutNotificationsByNotificationIdRead =
  'UsersNotificationsHttpPutNotificationsByNotificationIdRead' as const;
export const UsersNotificationsHttpGetSubscriptions =
  'UsersNotificationsHttpGetSubscriptions' as const;
export const UsersNotificationsHttpPostSubscriptions =
  'UsersNotificationsHttpPostSubscriptions' as const;
export const UsersNotificationsHttpDeleteSubscriptionsBySubscriptionId =
  'UsersNotificationsHttpDeleteSubscriptionsBySubscriptionId' as const;
export const UsersNotificationsHttpGetSubscriptionsBySubscriptionId =
  'UsersNotificationsHttpGetSubscriptionsBySubscriptionId' as const;
export const UsersNotificationsHttpDeleteUsersByUserIdDeviceTokens =
  'UsersNotificationsHttpDeleteUsersByUserIdDeviceTokens' as const;
export const UsersNotificationsHttpGetUsersByUserIdDeviceTokens =
  'UsersNotificationsHttpGetUsersByUserIdDeviceTokens' as const;
export const UsersNotificationsHttpPostUsersByUserIdDeviceTokens =
  'UsersNotificationsHttpPostUsersByUserIdDeviceTokens' as const;
export const UsersNotificationsHttpDeleteUsersByUserIdDeviceTokensByDeviceToken =
  'UsersNotificationsHttpDeleteUsersByUserIdDeviceTokensByDeviceToken' as const;
export const UsersNotificationsHttpGetUsersByUserIdDeviceTokensByDeviceToken =
  'UsersNotificationsHttpGetUsersByUserIdDeviceTokensByDeviceToken' as const;
export const UsersNotificationsHttpPatchUsersByUserIdDeviceTokensByDeviceToken =
  'UsersNotificationsHttpPatchUsersByUserIdDeviceTokensByDeviceToken' as const;
export const UsersNotificationsHttpGetByObjectTypeByObjectIdSubscriptions =
  'UsersNotificationsHttpGetByObjectTypeByObjectIdSubscriptions' as const;
export const UsersNotificationsHttpDeleteByObjectTypeByObjectIdSubscriptionsAll =
  'UsersNotificationsHttpDeleteByObjectTypeByObjectIdSubscriptionsAll' as const;

/**
 * Original schema `BaseQueryParamsSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/users-notifications/spec/#model-BaseQueryParamsSchema}
 */
export interface UsersNotificationsBaseQueryParamsSchema {
  /**
   * The number of items for each page
   */
  per_page?: number | null;
}
/**
 * Original schema `DeviceTokenSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/users-notifications/spec/#model-DeviceTokenSchema}
 */
export interface UsersNotificationsDeviceTokenSchema {
  app_bundle_id?: string;
  app_version?: string;
  date_created?: string;
  date_modified?: string;
  device_name?: string;
  device_token: string;
  failed_count?: number;
  is_active?: boolean;
  last_failed_at?: string;
  last_used_at?: string;
  platform: 'ios' | 'android';
  push_service?: 'apns' | 'fcm';
  system_domain_id?: string;
  user_id?: string;
}
/**
 * Original schema `DeviceTokensQueryParamsSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/users-notifications/spec/#model-DeviceTokensQueryParamsSchema}
 */
export interface UsersNotificationsDeviceTokensQueryParamsSchema {
  /**
   * The number of items for each page
   */
  per_page?: number | null;
}
/**
 * Original schema `DeviceTokensSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/users-notifications/spec/#model-DeviceTokensSchema}
 */
export interface UsersNotificationsDeviceTokensSchema {
  first_url?: string;
  last_url?: string;
  next_url?: string;
  objects?: UsersNotificationsDeviceTokenSchema[];
  page?: number;
  pages?: number;
  per_page?: number;
  prev_url?: string;
  total?: number;
}
/**
 * Original schema `ListObjectsSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/users-notifications/spec/#model-ListObjectsSchema}
 */
export interface UsersNotificationsListObjectsSchema {
  first_url?: string;
  last_url?: string;
  next_url?: string;
  page?: number;
  pages?: number;
  per_page?: number;
  prev_url?: string;
  total?: number;
}
/**
 * Original schema `NotificationSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/users-notifications/spec/#model-NotificationSchema}
 */
export interface UsersNotificationsNotificationSchema {
  context?: {
    [k: string]: unknown;
  };
  date_created?: string;
  date_modified?: string;
  event_type: string;
  exclude_users?: string[] | null;
  id?: string;
  message_long: string;
  message_short: string;
  object_id: string;
  object_type: string;
  recipient_id: string;
  sender_id: string;
  share_id?: string;
  share_user_id?: string;
  status?: 'QUEUED' | 'SENT' | 'READ';
  sub_object_id?: string;
  sub_object_type?: string;
  system_domain_id?: string;
  user_id?: string;
}
/**
 * Original schema `NotificationSettingSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/users-notifications/spec/#model-NotificationSettingSchema}
 */
export interface UsersNotificationsNotificationSettingSchema {
  enabled: boolean;
  event_type: string;
  object_type: string;
  protocol?: 'web' | 'email' | 'push';
  recipient_id?: string;
  settings?: {
    [k: string]: unknown;
  };
  sub_object_type?: string;
  system_domain_id?: string;
}
/**
 * Original schema `NotificationSettingsSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/users-notifications/spec/#model-NotificationSettingsSchema}
 */
export interface UsersNotificationsNotificationSettingsSchema {
  first_url?: string;
  last_url?: string;
  next_url?: string;
  objects?: UsersNotificationsNotificationSettingSchema[];
  page?: number;
  pages?: number;
  per_page?: number;
  prev_url?: string;
  total?: number;
}
/**
 * Original schema `NotificationsSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/users-notifications/spec/#model-NotificationsSchema}
 */
export interface UsersNotificationsNotificationsSchema {
  first_url?: string;
  last_url?: string;
  next_url?: string;
  objects?: UsersNotificationsNotificationSchema[];
  page?: number;
  pages?: number;
  per_page?: number;
  prev_url?: string;
  total?: number;
}
/**
 * Original schema `SubscriptionSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/users-notifications/spec/#model-SubscriptionSchema}
 */
export interface UsersNotificationsSubscriptionSchema {
  date_created?: string;
  date_modified?: string;
  event_type?: string;
  id?: string;
  object_id?: string;
  object_type: string;
  sub_object_id?: string;
  sub_object_type?: string;
  system_domain_id?: string;
  user_id?: string;
}
/**
 * Original schema `SubscriptionsSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/users-notifications/spec/#model-SubscriptionsSchema}
 */
export interface UsersNotificationsSubscriptionsSchema {
  first_url?: string;
  last_url?: string;
  next_url?: string;
  objects?: UsersNotificationsSubscriptionSchema[];
  page?: number;
  pages?: number;
  per_page?: number;
  prev_url?: string;
  total?: number;
}
/**
 * Original schema `SystemNotificationSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/users-notifications/spec/#model-SystemNotificationSchema}
 */
export interface UsersNotificationsSystemNotificationSchema {
  context?: {
    [k: string]: unknown;
  };
  date_created?: string;
  date_modified?: string;
  event_type: string;
  exclude_users?: string[] | null;
  id?: string;
  message_long: string;
  message_short: string;
  object_id?: string | null;
  object_type: string;
  recipient_id: string;
  sender_id: string;
  share_id?: string;
  share_user_id?: string;
  status?: ('QUEUED' | 'SENT' | 'READ') | null;
  sub_object_id?: string;
  sub_object_type?: string;
  system_domain_id: string;
  user_id?: string;
}
/**
 * Original schema `NotificationSettingsSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/users-notifications/spec/#model-NotificationSettingsSchema}
 */
export interface UsersNotificationsNotificationSettingsSchemaWithId {
  first_url?: string;
  last_url?: string;
  next_url?: string;
  objects: UsersNotificationsNotificationSettingSchemaNullable[];
  page: number;
  pages: number;
  per_page: number;
  prev_url?: string;
  total: number;
}
/**
 * Original schema `NotificationSettingSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/users-notifications/spec/#model-NotificationSettingSchema}
 */
export interface UsersNotificationsNotificationSettingSchemaNullable {
  enabled: boolean;
  event_type: string;
  object_type: string;
  protocol?: ('web' | 'email' | 'push') | null;
  recipient_id?: string | null;
  settings?: {
    [k: string]: unknown;
  } | null;
  sub_object_type?: string | null;
  system_domain_id?: string | null;
}
/**
 * Original schema `NotificationsSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/users-notifications/spec/#model-NotificationsSchema}
 */
export interface UsersNotificationsNotificationsSchemaWithId {
  first_url?: string;
  last_url?: string;
  next_url?: string;
  objects: UsersNotificationsNotificationSchemaWithIdNullable[];
  page: number;
  pages: number;
  per_page: number;
  prev_url?: string;
  total: number;
}
/**
 * Original schema `NotificationSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/users-notifications/spec/#model-NotificationSchema}
 */
export interface UsersNotificationsNotificationSchemaWithIdNullable {
  context?: {
    [k: string]: unknown;
  } | null;
  date_created?: string | null;
  date_modified?: string | null;
  event_type: string;
  exclude_users?: string[] | null;
  id: string;
  message_long: string;
  message_short: string;
  object_id: string;
  object_type: string;
  recipient_id: string;
  sender_id: string;
  share_id?: string | null;
  share_user_id?: string | null;
  status?: ('QUEUED' | 'SENT' | 'READ') | null;
  sub_object_id?: string | null;
  sub_object_type?: string | null;
  system_domain_id?: string | null;
  user_id?: string | null;
}
/**
 * Original schema `NotificationSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/users-notifications/spec/#model-NotificationSchema}
 */
export interface UsersNotificationsNotificationSchemaWithId {
  context?: {
    [k: string]: unknown;
  };
  date_created?: string;
  date_modified?: string;
  event_type: string;
  exclude_users?: string[] | null;
  id: string;
  message_long: string;
  message_short: string;
  object_id: string;
  object_type: string;
  recipient_id: string;
  sender_id: string;
  share_id?: string;
  share_user_id?: string;
  status?: 'QUEUED' | 'SENT' | 'READ';
  sub_object_id?: string;
  sub_object_type?: string;
  system_domain_id?: string;
  user_id?: string;
}
/**
 * Original schema `SubscriptionsSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/users-notifications/spec/#model-SubscriptionsSchema}
 */
export interface UsersNotificationsSubscriptionsSchemaWithId {
  first_url?: string;
  last_url?: string;
  next_url?: string;
  objects: UsersNotificationsSubscriptionSchemaWithIdNullable[];
  page: number;
  pages: number;
  per_page: number;
  prev_url?: string;
  total: number;
}
/**
 * Original schema `SubscriptionSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/users-notifications/spec/#model-SubscriptionSchema}
 */
export interface UsersNotificationsSubscriptionSchemaWithIdNullable {
  date_created?: string | null;
  date_modified?: string | null;
  event_type?: string | null;
  id: string;
  object_id?: string | null;
  object_type: string;
  sub_object_id?: string | null;
  sub_object_type?: string | null;
  system_domain_id?: string | null;
  user_id?: string | null;
}
/**
 * Original schema `SubscriptionSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/users-notifications/spec/#model-SubscriptionSchema}
 */
export interface UsersNotificationsSubscriptionSchemaWithId {
  date_created?: string;
  date_modified?: string;
  event_type?: string;
  id: string;
  object_id?: string;
  object_type: string;
  sub_object_id?: string;
  sub_object_type?: string;
  system_domain_id?: string;
  user_id?: string;
}
/**
 * Original schema `DeviceTokensSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/users-notifications/spec/#model-DeviceTokensSchema}
 */
export interface UsersNotificationsDeviceTokensSchemaWithId {
  first_url?: string;
  last_url?: string;
  next_url?: string;
  objects: UsersNotificationsDeviceTokenSchemaNullable[];
  page: number;
  pages: number;
  per_page: number;
  prev_url?: string;
  total: number;
}
/**
 * Original schema `DeviceTokenSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/users-notifications/spec/#model-DeviceTokenSchema}
 */
export interface UsersNotificationsDeviceTokenSchemaNullable {
  app_bundle_id?: string | null;
  app_version?: string | null;
  date_created?: string | null;
  date_modified?: string | null;
  device_name?: string | null;
  device_token: string;
  failed_count?: number | null;
  is_active?: boolean | null;
  last_failed_at?: string | null;
  last_used_at?: string | null;
  platform: 'ios' | 'android';
  push_service?: ('apns' | 'fcm') | null;
  system_domain_id?: string | null;
  user_id?: string | null;
}

/**
 * `POST /v1/device_tokens/`
 *
 * Register a new device token for push notifications
 *
 *
 * Responses
 * - 200 - Returns the updated device token (if token already exists)
 * - 201 - Returns the created device token
 * - 400 - Bad request
 * - 401 - Token is invalid
 * - 403 - Only admin users can manage device tokens
 *
 * Response {@link UsersNotificationsDeviceTokenSchema}
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/users-notifications/spec/#/default/post_v1_device_tokens_}
 */
export const httpPostDeviceTokens = (
  body: UsersNotificationsDeviceTokenSchema,
  headers?: IconikApiHeaders,
) => ({
  id: UsersNotificationsHttpPostDeviceTokens,
  method: httpMethod.post,
  url: '/API/users-notifications/v1/device_tokens/',

  body,
  headers,
});

export interface UsersNotificationsHttpGetNotificationSettingsQuery {
  /**
   * The number of items for each page
   */
  per_page?: number;
  /**
   * ID of the last notification setting on the previous page
   */
  last_id?: string;
}

/**
 * `GET /v1/notification_settings/`
 *
 * Returns a list of notification_settings
 *
 * Required roles:
 *  - can_read_notification_settings
 *
 * Responses
 * - 200 - Returns a list of notification settings
 * - 400 - Bad request
 * - 401 - Token is invalid
 *
 * Response {@link UsersNotificationsNotificationSettingsSchemaWithId}
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/users-notifications/spec/#/default/get_v1_notification_settings_}
 */
export const httpGetNotificationSettings = (
  query?: UsersNotificationsHttpGetNotificationSettingsQuery,
  headers?: IconikApiHeaders,
) => ({
  id: UsersNotificationsHttpGetNotificationSettings,
  method: httpMethod.get,
  url: '/API/users-notifications/v1/notification_settings/',

  query,
  headers,
});

/**
 * `GET /v1/notification_settings/{object_type}/{sub_object_type}/{event_type}/{protocol}/`
 *
 * Returns a particular notification_setting
 *
 * Required roles:
 *  - can_read_notification_settings
 *
 * Responses
 * - 200 - Returns a notification_setting
 * - 400 - Bad request
 * - 401 - Token is invalid
 * - 404 - NotificationSetting does not exist
 *
 * Response {@link UsersNotificationsNotificationSettingSchemaNullable}
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/users-notifications/spec/#/default/get_v1_notification_settings__object_type___sub_object_type___event_type___protocol__}
 */
export const httpGetNotificationSettingsByObjectTypeBySubObjectTypeByEventTypeByProtocol =
  (
    objectType: string,
    subObjectType: string,
    eventType: string,
    protocol: string,
    headers?: IconikApiHeaders,
  ) => ({
    id: UsersNotificationsHttpGetNotificationSettingsByObjectTypeBySubObjectTypeByEventTypeByProtocol,
    method: httpMethod.get,
    url: `/API/users-notifications/v1/notification_settings/${encodeURIComponent(objectType)}/${encodeURIComponent(subObjectType)}/${encodeURIComponent(eventType)}/${encodeURIComponent(protocol)}/`,
    params: { objectType, subObjectType, eventType, protocol },
    headers,
  });

/**
 * `PUT /v1/notification_settings/{object_type}/{sub_object_type}/{event_type}/{protocol}/`
 *
 * Create or update a notification_setting
 *
 *
 * Responses
 * - 201 - Returns a created or updated notification_setting
 * - 400 - Bad request
 * - 401 - Token is invalid
 *
 * Response {@link UsersNotificationsNotificationSettingSchema}
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/users-notifications/spec/#/default/put_v1_notification_settings__object_type___sub_object_type___event_type___protocol__}
 */
export const httpPutNotificationSettingsByObjectTypeBySubObjectTypeByEventTypeByProtocol =
  (
    objectType: string,
    subObjectType: string,
    eventType: string,
    protocol: string,
    body: UsersNotificationsNotificationSettingSchema,
    headers?: IconikApiHeaders,
  ) => ({
    id: UsersNotificationsHttpPutNotificationSettingsByObjectTypeBySubObjectTypeByEventTypeByProtocol,
    method: httpMethod.put,
    url: `/API/users-notifications/v1/notification_settings/${encodeURIComponent(objectType)}/${encodeURIComponent(subObjectType)}/${encodeURIComponent(eventType)}/${encodeURIComponent(protocol)}/`,
    params: { objectType, subObjectType, eventType, protocol },
    body,
    headers,
  });

export interface UsersNotificationsHttpGetNotificationsQuery {
  /**
   * The number of items for each page
   */
  per_page?: number;
  /**
   * ID of the last notification on the previous page
   */
  last_id?: string;
}

/**
 * `GET /v1/notifications/`
 *
 * Returns a list of notifications
 *
 * Required roles:
 *  - can_read_notifications
 *
 * Responses
 * - 200 - Returns a list of notifications
 * - 400 - Bad request
 * - 401 - Token is invalid
 * - 404 - Notification does not exist
 *
 * Response {@link UsersNotificationsNotificationsSchemaWithId}
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/users-notifications/spec/#/default/get_v1_notifications_}
 */
export const httpGetNotifications = (
  query?: UsersNotificationsHttpGetNotificationsQuery,
  headers?: IconikApiHeaders,
) => ({
  id: UsersNotificationsHttpGetNotifications,
  method: httpMethod.get,
  url: '/API/users-notifications/v1/notifications/',

  query,
  headers,
});

/**
 * `POST /v1/notifications/`
 *
 * Create a new notification
 *
 *
 * Responses
 * - 201 - Returns a created notification
 * - 400 - Bad request
 * - 401 - Token is invalid
 * - 403 - Only admin users can create system notifications
 *
 * Response {@link UsersNotificationsNotificationSchemaWithId}
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/users-notifications/spec/#/default/post_v1_notifications_}
 */
export const httpPostNotifications = (
  body: UsersNotificationsNotificationSchema,
  headers?: IconikApiHeaders,
) => ({
  id: UsersNotificationsHttpPostNotifications,
  method: httpMethod.post,
  url: '/API/users-notifications/v1/notifications/',

  body,
  headers,
});

/**
 * `PUT /v1/notifications/all/read/`
 *
 * Mark the latest 100 notifications as read
 *
 * Required roles:
 *  - can_read_notifications
 *
 * Responses
 * - 200 - Without body
 * - 400 - Bad request
 * - 401 - Token is invalid
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/users-notifications/spec/#/default/put_v1_notifications_all_read_}
 */
export const httpPutNotificationsAllRead = (headers?: IconikApiHeaders) => ({
  id: UsersNotificationsHttpPutNotificationsAllRead,
  method: httpMethod.put,
  url: '/API/users-notifications/v1/notifications/all/read/',

  headers,
});

/**
 * `POST /v1/notifications/system/`
 *
 * Create a new system notification
 *
 *
 * Responses
 * - 201 - Returns a created notification
 * - 400 - Bad request
 * - 401 - Token is invalid
 * - 403 - Only admin and super admin users can create system notifications
 *
 * Response {@link UsersNotificationsNotificationSchemaWithId}
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/users-notifications/spec/#/default/post_v1_notifications_system_}
 */
export const httpPostNotificationsSystem = (
  body: UsersNotificationsSystemNotificationSchema,
  headers?: IconikApiHeaders,
) => ({
  id: UsersNotificationsHttpPostNotificationsSystem,
  method: httpMethod.post,
  url: '/API/users-notifications/v1/notifications/system/',

  body,
  headers,
});

/**
 * `DELETE /v1/notifications/{notification_id}/`
 *
 * Delete a particular notification by id
 *
 * Required roles:
 *  - can_delete_notifications
 *
 * Responses
 * - 204 - Without body
 * - 400 - Bad request
 * - 401 - Token is invalid
 * - 404 - Notification does not exist
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/users-notifications/spec/#/default/delete_v1_notifications__notification_id__}
 */
export const httpDeleteNotificationsByNotificationId = (
  notificationId: string,
  headers?: IconikApiHeaders,
) => ({
  id: UsersNotificationsHttpDeleteNotificationsByNotificationId,
  method: httpMethod.delete,
  url: `/API/users-notifications/v1/notifications/${encodeURIComponent(notificationId)}/`,
  params: { notificationId },
  headers,
});

/**
 * `GET /v1/notifications/{notification_id}/`
 *
 * Returns a particular notification by id
 *
 * Required roles:
 *  - can_read_notifications
 *
 * Responses
 * - 200 - Returns a notification
 * - 400 - Bad request
 * - 401 - Token is invalid
 * - 404 - Notification does not exist
 *
 * Response {@link UsersNotificationsNotificationSchemaWithIdNullable}
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/users-notifications/spec/#/default/get_v1_notifications__notification_id__}
 */
export const httpGetNotificationsByNotificationId = (
  notificationId: string,
  headers?: IconikApiHeaders,
) => ({
  id: UsersNotificationsHttpGetNotificationsByNotificationId,
  method: httpMethod.get,
  url: `/API/users-notifications/v1/notifications/${encodeURIComponent(notificationId)}/`,
  params: { notificationId },
  headers,
});

/**
 * `PUT /v1/notifications/{notification_id}/read/`
 *
 * Mark a particular notification as read
 *
 * Required roles:
 *  - can_read_notifications
 *
 * Responses
 * - 200 - Returns the updated notification
 * - 400 - Bad request
 * - 401 - Token is invalid
 * - 404 - Notification does not exist
 *
 * Response {@link UsersNotificationsNotificationSchema}
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/users-notifications/spec/#/default/put_v1_notifications__notification_id__read_}
 */
export const httpPutNotificationsByNotificationIdRead = (
  notificationId: string,
  headers?: IconikApiHeaders,
) => ({
  id: UsersNotificationsHttpPutNotificationsByNotificationIdRead,
  method: httpMethod.put,
  url: `/API/users-notifications/v1/notifications/${encodeURIComponent(notificationId)}/read/`,
  params: { notificationId },
  headers,
});

/**
 * `GET /v1/subscriptions/`
 *
 * Returns all user subscriptions
 *
 * Required roles:
 *  - can_read_subscriptions
 *
 * Responses
 * - 200 - Returns a list of subscriptions
 * - 400 - Bad request
 * - 401 - Token is invalid
 * - 404 - Subscription does not exist
 *
 * Response {@link UsersNotificationsSubscriptionsSchemaWithId}
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/users-notifications/spec/#/default/get_v1_subscriptions_}
 */
export const httpGetSubscriptions = (headers?: IconikApiHeaders) => ({
  id: UsersNotificationsHttpGetSubscriptions,
  method: httpMethod.get,
  url: '/API/users-notifications/v1/subscriptions/',

  headers,
});

/**
 * `POST /v1/subscriptions/`
 *
 * Create a new subscription
 *
 *
 * Responses
 * - 201 - Returns a created subscription
 * - 400 - Bad request
 * - 401 - Token is invalid
 *
 * Response {@link UsersNotificationsSubscriptionSchemaWithId}
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/users-notifications/spec/#/default/post_v1_subscriptions_}
 */
export const httpPostSubscriptions = (
  body: UsersNotificationsSubscriptionSchema,
  headers?: IconikApiHeaders,
) => ({
  id: UsersNotificationsHttpPostSubscriptions,
  method: httpMethod.post,
  url: '/API/users-notifications/v1/subscriptions/',

  body,
  headers,
});

/**
 * `DELETE /v1/subscriptions/{subscription_id}/`
 *
 * Delete a particular subscription by id
 *
 * Required roles:
 *  - can_write_subscriptions
 *
 * Responses
 * - 204 - Without body
 * - 400 - Bad request
 * - 401 - Token is invalid
 * - 404 - Subscription does not exist
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/users-notifications/spec/#/default/delete_v1_subscriptions__subscription_id__}
 */
export const httpDeleteSubscriptionsBySubscriptionId = (
  subscriptionId: string,
  headers?: IconikApiHeaders,
) => ({
  id: UsersNotificationsHttpDeleteSubscriptionsBySubscriptionId,
  method: httpMethod.delete,
  url: `/API/users-notifications/v1/subscriptions/${encodeURIComponent(subscriptionId)}/`,
  params: { subscriptionId },
  headers,
});

/**
 * `GET /v1/subscriptions/{subscription_id}/`
 *
 * Returns a particular subscription by id
 *
 * Required roles:
 *  - can_read_subscriptions
 *
 * Responses
 * - 200 - Returns a subscription
 * - 400 - Bad request
 * - 401 - Token is invalid
 * - 404 - Subscription does not exist
 *
 * Response {@link UsersNotificationsSubscriptionSchemaWithIdNullable}
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/users-notifications/spec/#/default/get_v1_subscriptions__subscription_id__}
 */
export const httpGetSubscriptionsBySubscriptionId = (
  subscriptionId: string,
  headers?: IconikApiHeaders,
) => ({
  id: UsersNotificationsHttpGetSubscriptionsBySubscriptionId,
  method: httpMethod.get,
  url: `/API/users-notifications/v1/subscriptions/${encodeURIComponent(subscriptionId)}/`,
  params: { subscriptionId },
  headers,
});

/**
 * `DELETE /v1/users/{user_id}/device_tokens/`
 *
 * Unregister all device tokens for a user (e.g., on account deletion)
 *
 *
 * Responses
 * - 204 - All device tokens deleted successfully
 * - 401 - Token is invalid
 * - 403 - Only admin users can manage device tokens
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/users-notifications/spec/#/default/delete_v1_users__user_id__device_tokens_}
 */
export const httpDeleteUsersByUserIdDeviceTokens = (
  userId: string,
  headers?: IconikApiHeaders,
) => ({
  id: UsersNotificationsHttpDeleteUsersByUserIdDeviceTokens,
  method: httpMethod.delete,
  url: `/API/users-notifications/v1/users/${encodeURIComponent(userId)}/device_tokens/`,
  params: { userId },
  headers,
});

export interface UsersNotificationsHttpGetUsersByUserIdDeviceTokensQuery {
  /**
   * The number of items for each page
   */
  per_page?: number;
}

/**
 * `GET /v1/users/{user_id}/device_tokens/`
 *
 * Returns a list of device tokens for a user
 *
 *
 * Responses
 * - 200 - Returns a list of device tokens
 * - 400 - Bad request
 * - 401 - Token is invalid
 * - 403 - Only admin users can access device tokens
 *
 * Response {@link UsersNotificationsDeviceTokensSchemaWithId}
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/users-notifications/spec/#/default/get_v1_users__user_id__device_tokens_}
 */
export const httpGetUsersByUserIdDeviceTokens = (
  userId: string,
  query?: UsersNotificationsHttpGetUsersByUserIdDeviceTokensQuery,
  headers?: IconikApiHeaders,
) => ({
  id: UsersNotificationsHttpGetUsersByUserIdDeviceTokens,
  method: httpMethod.get,
  url: `/API/users-notifications/v1/users/${encodeURIComponent(userId)}/device_tokens/`,
  params: { userId },
  query,
  headers,
});

/**
 * `POST /v1/users/{user_id}/device_tokens/`
 *
 * Register a new device token for push notifications
 *
 *
 * Responses
 * - 200 - Returns the updated device token (if token already exists)
 * - 201 - Returns the created device token
 * - 400 - Bad request
 * - 401 - Token is invalid
 * - 403 - Only admin users can manage device tokens
 *
 * Response {@link UsersNotificationsDeviceTokenSchema}
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/users-notifications/spec/#/default/post_v1_users__user_id__device_tokens_}
 */
export const httpPostUsersByUserIdDeviceTokens = (
  userId: string,
  body: UsersNotificationsDeviceTokenSchema,
  headers?: IconikApiHeaders,
) => ({
  id: UsersNotificationsHttpPostUsersByUserIdDeviceTokens,
  method: httpMethod.post,
  url: `/API/users-notifications/v1/users/${encodeURIComponent(userId)}/device_tokens/`,
  params: { userId },
  body,
  headers,
});

/**
 * `DELETE /v1/users/{user_id}/device_tokens/{device_token}/`
 *
 * Unregister a device token
 *
 *
 * Responses
 * - 204 - Device token deleted successfully
 * - 401 - Token is invalid
 * - 403 - Only admin users can manage device tokens
 * - 404 - Device token does not exist
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/users-notifications/spec/#/default/delete_v1_users__user_id__device_tokens__device_token__}
 */
export const httpDeleteUsersByUserIdDeviceTokensByDeviceToken = (
  userId: string,
  deviceToken: string,
  headers?: IconikApiHeaders,
) => ({
  id: UsersNotificationsHttpDeleteUsersByUserIdDeviceTokensByDeviceToken,
  method: httpMethod.delete,
  url: `/API/users-notifications/v1/users/${encodeURIComponent(userId)}/device_tokens/${encodeURIComponent(deviceToken)}/`,
  params: { userId, deviceToken },
  headers,
});

/**
 * `GET /v1/users/{user_id}/device_tokens/{device_token}/`
 *
 * Returns a particular device token
 *
 *
 * Responses
 * - 200 - Returns a device token
 * - 400 - Bad request
 * - 401 - Token is invalid
 * - 403 - Only admin users can access device tokens
 * - 404 - Device token does not exist
 *
 * Response {@link UsersNotificationsDeviceTokenSchemaNullable}
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/users-notifications/spec/#/default/get_v1_users__user_id__device_tokens__device_token__}
 */
export const httpGetUsersByUserIdDeviceTokensByDeviceToken = (
  userId: string,
  deviceToken: string,
  headers?: IconikApiHeaders,
) => ({
  id: UsersNotificationsHttpGetUsersByUserIdDeviceTokensByDeviceToken,
  method: httpMethod.get,
  url: `/API/users-notifications/v1/users/${encodeURIComponent(userId)}/device_tokens/${encodeURIComponent(deviceToken)}/`,
  params: { userId, deviceToken },
  headers,
});

export type UsersNotificationsDeviceTokenSchemaPartial =
  Partial<UsersNotificationsDeviceTokenSchema>;

/**
 * `PATCH /v1/users/{user_id}/device_tokens/{device_token}/`
 *
 * Update device token metadata
 *
 *
 * Responses
 * - 200 - Returns the updated device token
 * - 400 - Bad request
 * - 401 - Token is invalid
 * - 403 - Only admin users can manage device tokens
 * - 404 - Device token does not exist
 *
 * Response {@link UsersNotificationsDeviceTokenSchema}
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/users-notifications/spec/#/default/patch_v1_users__user_id__device_tokens__device_token__}
 */
export const httpPatchUsersByUserIdDeviceTokensByDeviceToken = (
  userId: string,
  deviceToken: string,
  body: UsersNotificationsDeviceTokenSchemaPartial,
  headers?: IconikApiHeaders,
) => ({
  id: UsersNotificationsHttpPatchUsersByUserIdDeviceTokensByDeviceToken,
  method: httpMethod.patch,
  url: `/API/users-notifications/v1/users/${encodeURIComponent(userId)}/device_tokens/${encodeURIComponent(deviceToken)}/`,
  params: { userId, deviceToken },
  body,
  headers,
});

/**
 * `GET /v1/{object_type}/{object_id}/subscriptions/`
 *
 * Returns user subscriptions for a specific object_type and object_id
 *
 * Required roles:
 *  - can_read_subscriptions
 *
 * Responses
 * - 200 - Returns a list of subscriptions
 * - 400 - Bad request
 * - 401 - Token is invalid
 * - 404 - Subscription does not exist
 *
 * Response {@link UsersNotificationsSubscriptionsSchemaWithId}
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/users-notifications/spec/#/default/get_v1__object_type___object_id__subscriptions_}
 */
export const httpGetByObjectTypeByObjectIdSubscriptions = (
  objectType: string,
  objectId: string,
  headers?: IconikApiHeaders,
) => ({
  id: UsersNotificationsHttpGetByObjectTypeByObjectIdSubscriptions,
  method: httpMethod.get,
  url: `/API/users-notifications/v1/${encodeURIComponent(objectType)}/${encodeURIComponent(objectId)}/subscriptions/`,
  params: { objectType, objectId },
  headers,
});

/**
 * `DELETE /v1/{object_type}/{object_id}/subscriptions/all/`
 *
 * Delete all user subscriptions for a specific object_type and object_id
 *
 * Required roles:
 *  - can_read_subscriptions
 *
 * Responses
 * - 204 - Without body
 * - 400 - Bad request
 * - 401 - Token is invalid
 * - 404 - Subscription does not exist
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/users-notifications/spec/#/default/delete_v1__object_type___object_id__subscriptions_all_}
 */
export const httpDeleteByObjectTypeByObjectIdSubscriptionsAll = (
  objectType: string,
  objectId: string,
  headers?: IconikApiHeaders,
) => ({
  id: UsersNotificationsHttpDeleteByObjectTypeByObjectIdSubscriptionsAll,
  method: httpMethod.delete,
  url: `/API/users-notifications/v1/${encodeURIComponent(objectType)}/${encodeURIComponent(objectId)}/subscriptions/all/`,
  params: { objectType, objectId },
  headers,
});
